import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { SearchMultiSelect } from '@gate/gui-business'
import { useAdapter } from '@/components/Adapter'
import { FundingSearchStyled } from './style'
import { useTranslation } from 'next-i18next'
import BaseEmpty from '@/components/BaseEmpty'
import { Flex } from '@mantine/core'

interface FundingSearchProps {
  handleFundingSelect: (val: string[]) => void
  fundingInvestVal: string[]
  fundSearchList: string[]
}

const FundingSearch: React.FC<FundingSearchProps> = ({
  handleFundingSelect,
  fundingInvestVal,
  fundSearchList,
  ...other
}) => {
  const { t } = useTranslation()
  const { isH5 } = useAdapter()

  const currentList = useMemo(() => {
    if (fundSearchList?.length) {
      return fundSearchList?.map(item => {
        return {
          label: item,
          value: item,
        }
      })
    }

    return []
  }, [fundSearchList])

  return (
    <FundingSearchStyled>
      <SearchMultiSelect
        nothingFound={
          <Flex mt={-12} w={'100%'} h={220} justify="center" align="center">
            <BaseEmpty size="md" type="search" />
          </Flex>
        }
        searchPlaceholder={t('P.Search') + ''}
        emptyLabel={t('P.NoRecord') + ''}
        w={isH5 ? '94vw' : 232}
        data={currentList}
        value={fundingInvestVal}
        onChange={val => {
          const currentVal = fundSearchList?.filter(item => val?.includes(item))
          handleFundingSelect(currentVal)
        }}
        {...other}
        styles={{
          dropdown: {
            '.gui-mantine-rtl-GateInput-wrapper, .mantine-GateInput-wrapper': {
              marginTop: '12px !important',
            },
          },
        }}
      />
    </FundingSearchStyled>
  )
}

export default observer(FundingSearch)
